import { schema } from 'normalizr';
import { SCHEMA_TYPE_MARKETPLACE_ITEMS } from 'js/constants/schemaTypes';
import orgSchema from './org';
import { apiKeySchema } from './apiKey';

const marketplaceItemSchema = new schema.Entity(SCHEMA_TYPE_MARKETPLACE_ITEMS, {
  org: orgSchema,
  api_keys: [apiKeySchema],
});

export default marketplaceItemSchema;
